// extracted by mini-css-extract-plugin
export default {"container":"filter_dropdown-module__container--P8hxe"};